export const getItemWorkflowTableRowState = (quantity, receiptedQuantity, blockedQuantity) => {
    if (blockedQuantity !== undefined && blockedQuantity > 0)
        return 'blocked';
    if (quantity === receiptedQuantity)
        return 'complete';
    if (receiptedQuantity > 0)
        return 'incomplete';
    return null;
};
